import { queryCache } from 'react-query'
import { logout } from '../auth-provider'
const apiURL = process.env.REACT_APP_API_URL || '/api'

export async function client(
  endpoint,
  { data, headers: customHeaders, ...customConfig } = {},
  dataType = 'json'
) {
  const config = {
    method: data ? 'POST' : 'GET',
    body: data ? JSON.stringify(data) : undefined,
    headers: {
      'Content-Type': data ? `application/${dataType}` : undefined,
      ...customHeaders,
    },
    ...customConfig,
  }

  const url = `${apiURL}/${endpoint}`.replace(/[/]{2,}/g, '/')

  return window.fetch(url, config).then(async response => {
    if (response.status === 401) {
      queryCache.clear()
      await logout()
      // refresh the page
      window.location.assign(window.location)
      return Promise.reject({ message: 'Please re-authenticate.' })
    }
    const data = await response.json()
    if (response.ok) {
      console.debug(data)
      return data
    } else {
      return Promise.reject(data)
    }
  })
}
